import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { LayoutModule } from "app/components/templates/layout/layout.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { UpdatePaymentMethodComponent } from "app/components/molecules/update-payment-method/update-payment-method.component";
import { IconModule } from "app/components/atoms/icon/icon.module";

@NgModule({
  declarations: [UpdatePaymentMethodComponent],
  exports: [UpdatePaymentMethodComponent],
  imports: [
    CommonModule,
    TranslateModule,
    LayoutModule,
    NgSelectModule,
    FormsModule,
    IconModule,
  ],
})
export class UpdatePaymentMethodModule {}
